import { get, toUpper, chain } from "lodash"
import { createSelector } from "reselect"
import { getMostUsedOrDefaultModelId } from "helpers/models"
import { getUserPreference } from "helpers/userPreferences"
import { getModel as getHomeSelectedModel } from "modules/home-layout/selectors/model"
import { getRawSelectedModelId } from "selectors/queryString"
import { getPortfolios } from "selectors/portfolios"
import { getModels } from "resources/models"

export const getSelectedScreen = (_, props) => get(props, "params.screen", "factors")
const getRawLastModelPreferences = state => get(state, "global.data.marketToolsModelPreferences.data")

const getDefaultModelId = createSelector(
  [getPortfolios, getModels],
  getMostUsedOrDefaultModelId,
)

const getPreferenceModelId = createSelector(
  [getRawLastModelPreferences],
  lastModelUsedPreferences => getUserPreference(lastModelUsedPreferences, "marketToolsLastModelUsed"),
)

export const getSelectedModelId = createSelector(
  [getRawSelectedModelId, getModels, getHomeSelectedModel, getPreferenceModelId, getDefaultModelId],
  (rawQuerystringModelId, homeSelectedModelId, preferenceModelId, accountDefaultModelId) => {
    const querystringModelId = toUpper(rawQuerystringModelId)
    return querystringModelId || preferenceModelId || homeSelectedModelId || accountDefaultModelId
  },
)

export const getSelectedModelName = createSelector(
  [getSelectedModelId, getModels],
  (selectedModelId, models) => chain(models)
    .find(model => model.id === selectedModelId)
    .get("name")
    .value(),
)
